﻿import negativeUiSfx from '@/assets/sounds/ui-negative-response.mp3'
import positiveUiSfx from '@/assets/sounds/ui-positive-response.mp3'
import finishedTaskSfx from '@/assets/sounds/ui-finished-task.mp3'
import decisionNeededSfx from '@/assets/sounds/ui-decision-needed.mp3'
import { useSound } from '@vueuse/sound'

export function useNegativeSound () {
	return useSound( negativeUiSfx )
}

export function usePositiveSound () {
	return useSound( positiveUiSfx )
}

export function useFinishedTaskSound () {
	return useSound( finishedTaskSfx )
}

export function useDecisionNeeded () {
	return useSound( decisionNeededSfx )
}
